import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import ROSIChart from "./ROSIChart";
import firebase from "firebase/compat/app";
import { Chart as ChartJS, registerables } from "chart.js";
ChartJS.register(...registerables);

const Chapter7_4 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welche Rolle spielen Schulungen und Sensibilisierungsprogramme bei der Risikominderung?",
      options: [
        {
          value: "A",
          label:
            "Sie sind nur für technische Mitarbeiter relevant, da andere Abteilungen keine Sicherheitsrisiken mit sich bringen.",
        },
        {
          value: "B",
          label:
            "Sie helfen, das Sicherheitsbewusstsein der Mitarbeiter zu stärken und das Risiko menschlicher Fehler zu verringern.",
        },
      ],
      correct: "B",
    },
    {
      question:
        "Frage 2: Warum ist ein regelmäßiges Patch-Management wichtig für die Cybersecurity?",
      options: [
        {
          value: "A",
          label:
            "Es schließt bekannte Schwachstellen und schützt Systeme vor Angriffen, die diese Schwachstellen ausnutzen könnten.",
        },
        {
          value: "B",
          label:
            "Es hilft, die Performance von IT-Systemen zu verbessern.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 7_4.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "7_4",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("7_4"),
            });
          console.log("Dokument aktualisiert mit Kapitel 7_4.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "7_4",
              completedChapters: ["7_4"],
            });
          console.log("Dokument erstellt mit Kapitel 7_4");
        }

        navigate("/cybersecurity/7_5"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  7. IT-Risikomanagement
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Risikosteuerung</li>        </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 7: IT-Risikomanagement</h3>
          <h2 className="text-center pb-5">Risikosteuerung </h2>
          <img
            src="/images/strategien.webp"
            alt="Strategien"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="col-lg-11 mx-auto">
            Unternehmen haben mehrere Möglichkeiten, auf identifizierte Risiken
            zu reagieren. Die Wahl der Strategie hängt von der
            Wahrscheinlichkeit, den potenziellen Auswirkungen und den
            verfügbaren Ressourcen ab. Nicht alle Risiken sind gleich bedeutsam.
            Die wichtigsten Strategien sind die Risikominderung, die
            Risikovermeidung, die Risikoübertragung und die Risikoakzeptanz.
          </p>
          <h2 className="col-lg-11 p-5 text-center mx-auto">
            Risikovermeidung
          </h2>

          <p className="col-lg-11 text-center mx-auto">
            Bei der Risikovermeidung wird das Risiko möglichst vollständig
            eliminiert, indem die Ursache des Risikos beseitigt wird. Diese
            Methode empfiehlt sich, wenn die potenziellen Auswirkungen
            eines Risikos untragbar oder die Kosten für andere
            Risikosteuerungsmaßnahmen unverhältnismäßig hoch sind. 
          </p>
          <p className="col-lg-9 text-start mx-auto">
            <strong>Einstellung einer unsicheren Geschäftspraxis: </strong>{" "}
            Unternehmen beenden Prozesse, die nicht gängigen Sicherheitsstandards
            entsprechen, wie etwa die Nutzung unsicherer Kommunikationskanäle. <br />
            Beispiel: Ein Unternehmen entscheidet, keine Kundendaten mehr über
            unverschlüsselte E-Mails zu versenden, um das Risiko eines
            Datenlecks zu vermeiden.
            <br /> <br />
            <strong>Verzicht auf veraltete Technologien: </strong> Der Austausch
            veralteter Hardware oder Software durch moderne, sicherere
            Alternativen.<br /> Beispiel: Ein Unternehmen ersetzt ein altes
            IT-System, das keine Sicherheitsupdates mehr erhält, durch eine
            cloudbasierte Lösung mit moderner Verschlüsselung.
            <br /> <br />
            <strong>Vermeidung bestimmter Märkte oder Partner: </strong>{" "}
            Unternehmen vermeiden Zusammenarbeit mit Geschäftspartnern oder den
            Eintritt in Märkte, die mit erhöhten Sicherheitsrisiken verbunden
            sind. <br />Beispiel: Ein Unternehmen verzichtet darauf, in Länder mit unsicheren
            rechtlichen Rahmenbedingungen oder hoher Cyberkriminalität zu
            expandieren.
            <br /> <br />
          </p>
          <p className="col-lg-11 text-center mx-auto">
            Die Risikovermeidung führt zu {" "}
            <strong>klaren Sicherheitsgewinnen, </strong> indem
            Technologien oder Praktiken nicht zum Einsatz kommen. Zudem
            sorgt der Austausch veralteter Systeme oder risikobehafteter
            Prozesse häufig für <strong>langfristige Effizienzgewinne, </strong>{" "}
            da modernere Alternativen implementiert werden, die
            Zeit und Kosten sparen.
            <br /> <br />
            Allerdings kann der Verzicht auf bestimmte Technologien oder Märkte
            die <strong>
              Geschäftsmöglichkeiten erheblich einschränken.{" "}
            </strong>{" "}
            Darüber hinaus können die Umsetzungskosten, beispielsweise für den
            Austausch von Technologien oder die Änderung von Prozessen, anfangs
            sehr hoch sein. In einigen Fällen ist die Risikovermeidung zudem
            schlichtweg nicht praktikabel, insbesondere wenn das Risiko aus
            unvermeidbaren Geschäftsprozessen resultiert.
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="p-5 ">
            <h2 className="col-lg-11 p-5 text-center mx-auto">
              Risikominderung
            </h2>

            <p className="col-lg-11 mx-auto">
              Bei der Risikominderung geht es darum, entweder die Eintrittswahrscheinlichkeit oder die potenzielle Verlusthöhe zu senken. 
              Risikominderung wird durch die Implementierung gezielter
              Sicherheitsmaßnahmen erreicht, die z. B. die Schwachstellen
              eines Systems reduzieren oder die potenziellen Auswirkungen einer
              Bedrohung begrenzen können. 
              <br />
              <br />
              Die Maßnahmen zur Risikominderung umfassen{" "}
              <strong>technologische Maßnahmen </strong> wie Sicherheitsupdates,
              Netzwerksicherheit, Verschlüsselung und{" "}
              <Link to="/cybersecurity/4_3#zerotrust" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Zero Trust Architektur.
              </Link>{" "}
              <br />
              <br />
             <strong>Organisatorische Maßnahmen </strong> sind dabei z. B. 
              Mitarbeiterschulungen, Richtlinien und Prozesse und Notfallpläne.
              <br />
              <br />
              <strong> Physische Maßnahmen </strong> wie Zugangskontollen zu
              sensiblen Bereichen und Sicherung der Hardware vor Diebstahl oder
              Manipulation.
              <br />
              <br />
            </p>
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 ">
            <h2 className="col-lg-11 p-5 text-center mx-auto">
              Risikoübertragung
            </h2>

            <p className="col-lg-11 mx-auto">
              Es besteht außerdem die Möglichkeit, Risiken auf Dritte zu übertragen.
              Die zwei
              gängigsten Strategien zur Risikoübertragung sind{" "}
              <strong>Cyber-Versicherungen</strong> und das{" "}
              <strong>Outsourcing</strong> bestimmter Prozesse an externe
              Dienstleister.
            </p>

            <h3 className="p-5">Cyber-Versicherungen</h3>
            <p className="col-lg-11 mx-auto">
             Cyber-Versicherungen wurden speziell
              für Risiken im Bereich der Cybersecurity entwickelt. Sie helfen
              Unternehmen, finanzielle Verluste abzufedern, die durch
              Cyberangriffe, Datenverluste oder andere Schadensfälle entstehen könnten.
              <br />
              <br />
              <strong>Durch Cyber-Versicherungen abdeckbare Kosten:</strong> <br />
            </p>
            <p className="col-lg-10 mx-auto">
              <ul className="text-start">
                <li>
                  Kosten für Datenwiederherstellung und Systemreparatur: 
                  Bereinigung von Systemen und die Behebung der Ursachen eines
                  Angriffs.
                </li>
                <li>
                  Kosten für die Benachrichtigung betroffener Parteien (z. B.
                  Kunden) bei Datenschutzverletzungen: Die Versicherung
                  übernimmt diese Kommunikationskosten und unterstützt
                  gegebenenfalls bei der Krisenkommunikation.
                </li>
                <li>
                  Rechtskosten und Haftpflicht: Die Versicherung hilft, Anwalts-
                  und Gerichtskosten zu decken, wenn rechtliche Ansprüche auf das
                  Unternehmen zukommen. Sie übernimmt unter Umständen auch
                  Schadensersatzzahlungen an betroffene Dritte.
                </li>
                <li>
                  Kosten durch Betriebsunterbrechungen: Insbesondere{" "}
                  <Link to="/cybersecurity/3_2" className="icon-link">
                    {" "}
                    <svg className="bi" aria-hidden="true">
                      {" "}
                      <use xlinkHref="#book"></use>{" "}
                    </svg>{" "}
                    Ransomware{" "}
                  </Link>{" "}
                  -Angriffe können dazu führen, dass ein Unternehmen
                  vorübergehend keine Dienstleistungen mehr anbieten kann. Die
                  Versicherung übernimmt in solchen Fällen gegebenenfalls die finanziellen
                  Einbußen, die durch den Ausfall entstehen.
                </li>
                <li>
                  Schutz vor Erpressung durch{" "}
                  <Link to="/cybersecurity/2_4" className="icon-link">
                    {" "}
                    <svg className="bi" aria-hidden="true">
                      {" "}
                      <use xlinkHref="#book"></use>{" "}
                    </svg>{" "}
                    Phishing:{" "}
                  </Link>{" "}
                  Viele Cyberversicherungen decken Lösegeldzahlungen oder die
                  Kosten für die Verhandlungen mit Erpressern ab, falls das
                  Unternehmen Opfer eines Ransomware-Angriffs wird. Auch die
                  Beratung durch spezialisierte Sicherheitsfirmen kann hier Teil
                  des Versicherungsschutzes sein.{" "}
                </li>
              </ul>
            </p>
            <p className="pt-3 col-lg-11 mx-auto">
              <br />
              <strong>
                Voraussetzungen, Anforderungen und Ausschlussklauseln in Cyber-Versicherungsverträgen:{" "}
              </strong>
              :<br />
              <br />
              Cyber-Versicherungen setzen häufig voraus, dass das Unternehmen
              bestimmte Sicherheitsvorkehrungen getroffen hat. Dazu gehören z.
              B. ein implementiertes Patch-Management, Zugangskontrollen und
              regelmäßige Sicherheitsüberprüfungen. Versicherer erwarten, dass
              Unternehmen nachweisen können, dass sie präventiv gegen
              Bedrohungen vorgehen, um das Risiko eines Schadens zu minimieren.
              Demnach sind Schäden durch grobe Fahrlässigkeit oder vorsätzliches
              Fehlverhalten von der Deckung ausgenommen.
            </p>
  <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Im Jahr 2017 wurde Mondelez International, eines der größten
              Nahrungsmittelunternehmen der Welt und Hersteller von Oreo und
              Toblerone, Opfer des NotPetya-Cyberangriffs. Dieser Angriff betraf
              Unternehmen weltweit und verursachte erhebliche wirtschaftliche
              Verluste. <br />
              <br />
              Mondelez erlitt einen Schaden in Höhe von über 100 Millionen
              US-Dollar durch gestohlene Daten und beschädigte Systeme und
              klagte gegen ihren Versicherer Zurich Insurance, da dieser sich
              weigerte, den Schaden zu zahlen.
              <br />
              <br />
              Zurich Insurance berief sich auf eine Kriegsausschlussklausel im
              Versicherungsvertrag, die besagt, dass die Versicherung nicht für
              Schäden durch "kriegsähnliche Handlungen" oder Angriffe durch
              staatliche Akteure zahlen müsse. Da NotPetya mutmaßlich von
              russischen Akteuren im Zusammenhang mit dem Konflikt in der
              Ukraine gestartet wurde, stufte Zurich diesen Angriff als
              "kriegsähnlich" ein. <br />
              <br />
              Mondelez argumentierte, dass der Angriff auf Zivilunternehmen
              abzielte und nicht direkt als Kriegshandlung betrachtet werden
              könne. Der Rechtsstreit zog sich über Jahre hin und führte zu
              einer breiten Diskussion über die Notwendigkeit,
              Cyber-Versicherungen zu überarbeiten und spezifischere Ausschlüsse
              zu definieren.
              <br />
              <br />
              Der Fall machte deutlich, dass Ausschlussklauseln und eine
              präzise Definition der Deckung im Vertrag extrem wichtig sind. Er
              führte dazu, dass viele Unternehmen und Versicherer ihre Verträge
              und die Bedingungen für den Cyber-Versicherungsschutz
              überarbeiteten, insbesondere in Bezug auf staatlich gesponserte
              Angriffe und kriegsähnliche Ausschlüsse. Es verdeutlicht auch,
              dass Unternehmen ihre Verträge genau prüfen und sich über mögliche
              Ausschlüsse und Einschränkungen bewusst sein müssen.
            </p>


            
            <p className="pt-3 col-lg-11 mx-auto">
              <strong>Best Practices bei Cyberversicherungsverträgen: </strong>
              <br />
              <br />
              Ein guter Cyberversicherungsvertrag wird den{" "}
              <strong>Deckungsumfang</strong> klar definieren und{" "}
              <strong>Ausschlussklauseln</strong> wie kriegsähnliche Handlungen
              berücksichtigen. Versicherer verlangen oft bestimmte{" "}
              <strong>Sicherheitsmaßnahmen</strong> (z. B. regelmäßige Patches,
              MFA), die erfüllt sein müssen, um den Schutz nicht zu verlieren.
              Zudem sollten <strong>Reaktionskosten</strong> wie IT-Forensik und
              Krisenkommunikation abgedeckt sein. Eine{" "}
              <strong>regelmäßige Überprüfung</strong> des Vertrags stellt
              sicher, dass die Versicherung auf aktuelle Risiken abgestimmt
              bleibt.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Durch die Risikoübertragung mit Cyber-Versicherung kann ein neuen Risikos entstehen. Das Risiko der "Moral Hazard" (moralisches
              Risiko). Wenn Unternehmen auf eine Versicherung vertrauen, kann
              dies dazu führen, dass sie weniger in präventive
              Sicherheitsmaßnahmen investieren. Ein gutes Risikomanagement
              sollte daher sicherstellen, dass die Versicherung nur eine
              Ergänzung, aber kein Ersatz für Cybersecurity-Maßnahmen ist.
            </p>
            </div>
</div>
 <div className="grey-section">
        <div className="container p-5">


            <h2 className="p-5">Outsourcing</h2>
            <p className="col-lg-11 mx-auto">
              Outsourcing bedeutet, dass ein Unternehmen bestimmte IT- oder
              Cybersecurity-Prozesse an <strong>externe Dienstleister </strong>{" "}
              auslagert. Damit können spezialisierte Dienstleistungen und
              Technologien genutzt werden, die intern oft kostspielig oder
              aufwendig umzusetzen wären. Der Risikotransfer erfolgt hierbei
              dadurch, dass der Dienstleister dann für bestimmte
              Sicherheitsmaßnahmen verantwortlich ist.
              <br />
              <br />
              Besonders kleinere Unternehmen profitieren davon, da sie nicht
              über die finanziellen Mittel verfügen, um umfassende
              Sicherheitslösungen intern umzusetzen. Auch Unternehmen, die nicht
              rund um die Uhr Sicherheitsüberwachung gewährleisten können,
              erhalten durch Outsourcing Zugang zu kontinuierlicher Überwachung
              und schneller Reaktionszeit im Ernstfall. Typische Beispiele für ausgelagerte
              Prozesse sind:
              <br />
              <br /> <br />
              <strong>Cloud-Speicher und Datenhosting</strong>: Die Nutzung
              externer Cloud-Anbieter für die Speicherung sensibler Daten oder
              die Bereitstellung von Anwendungen ist ein häufiges Beispiel für
              Outsourcing. Der Cloud-Anbieter ist dabei für die Verfügbarkeit
              und Sicherheit der Daten verantwortlich.
              <br />
              <br />
              <br />
              <strong>Netzwerksicherheit und Überwachung</strong>: Viele
              Unternehmen lagern Netzwerksicherheit wie Intrusion Detection,
              <Link to="/cybersecurity/4_3#firewall" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Firewall-Management,
              </Link>{" "}
              oder Sicherheitsüberwachung an spezialisierte Anbieter aus, die
              24/7-Monitoring bieten und im Ernstfall schnell reagieren.
              <br />
              <br />
              <br />
              <strong>
                {" "}
                <Link to="/cybersecurity/3_2#backup" className="icon-link">
                  <svg className="bi" aria-hidden="true">
                    <use xlinkHref="#book"></use>
                  </svg>{" "}
                  Backups
                </Link>{" "}
                und{" "}
                <Link to="/cybersecurity/4_5#dr" className="icon-link">
                  <svg className="bi" aria-hidden="true">
                    <use xlinkHref="#book"></use>
                  </svg>{" "}
                  Disaster Recovery:
                </Link>
              </strong>
              Auch für die Durchführung und Verwaltung regelmäßiger Backups und
              für Notfallwiederherstellungspläne können externe Anbieter
              verantwortlich sein. Diese Dienstleister bieten oft geografisch
              verteilte Speichersysteme an, die eine höhere Ausfallsicherheit
              bieten als interne Speicherlösungen.
              <br />
              <br />
              <br />
              Beim Outsourcing wird vertraglich genau festgelegt,
              welche Sicherheitsstandards und -maßnahmen der Dienstleister
              einzuhalten hat. Dies erfolgt in der Regel über{" "}
              <strong>Service Level Agreements (SLAs)</strong>. Verträge, die
              klar definieren, welche Sicherheitsvorkehrungen getroffen werden,
              wie schnell auf Vorfälle reagiert werden muss und welche
              Haftungsbedingungen gelten. Ein gut formuliertes SLA stellt
              sicher, dass der Dienstleister für bestimmte Vorfälle
              verantwortlich ist und die Sicherheitsverantwortung mitträgt.
            </p>
          </div>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container p-5">
          <div className="p-5 ">
            <h2 className="col-lg-11 p-5 text-center mx-auto">
              Akzeptanz von Rest-Risiken
            </h2>
            <p className="col-lg-11 mx-auto">
              Im Risikomanagement gibt es immer Risiken, die sich nicht
              vollständig eliminieren oder mindern lassen. Die verbleibenden
              Risiken, die als <strong>Rest-Risiken</strong> bezeichnet werden,
              können oder müssen unter bestimmten Bedingungen akzeptiert werden. <br />
              <br />
              Das <strong>Akzeptieren von Rest-Risiken</strong> ist ein bewusster
              und strategischer Schritt, bei dem das Unternehmen festlegt,
              welche Risiken hinzunehmen sind. Das können Risiken mit sehr niedriger Eintrittswahrscheinlichkeit sein. Es können Risiken mit sehr niedriger Verlusthöhe sein. Es kann aber auch sein, das Steuerungsmaßnahmen für extreme Risiken derart kostspielig sind, dass Unternehmen aus Wirtschaftlichkeitsüberlegungen diese Risiken einfach hinnehmen müssen.  Die Entscheidung, ob
              ein Rest-Risiko akzeptiert werden kann, erfordert eine sorgfältige
              Analyse der potenziellen Auswirkungen und der Wahrscheinlichkeit,
              mit der dieses Risiko eintreten könnte.
            </p>
            <h3 className="p-5">Entscheidung zur Akzeptanz</h3>
            <p className="col-lg-11 mx-auto">
              Die Akzeptanz von Rest-Risiken ist in der Regel eine{" "}
              <strong> Managemententscheidung. </strong>
              Das Führungsteam muss die verbleibenden Risiken abwägen und
              entscheiden, ob die möglichen Auswirkungen für das Unternehmen
              akzeptabel sind. Diese strategische Entscheidung wird immer unter Berücksichtigung der wirtschaftlichen Interessen des
              Unternehmens getroffen.
              <br />
              <br />
              Akzeptierte Risiken sollten klar dokumentiert werden,
              einschließlich der Begründung, warum diese Risiken als akzeptabel
              eingestuft wurden. Die{" "}
              <strong>Dokumentation der Risikoakzeptanz </strong> dient als
              Nachweis, dass die Entscheidung bewusst getroffen wurde und das
              Unternehmen über das verbleibende Risiko informiert ist. Sie
              bietet zudem eine Grundlage für zukünftige Risikoevaluierungen.
              <br />
              <br />
              Risiken, die als akzeptabel eingestuft wurden, sollten
              <strong> regelmäßig überprüft </strong> werden. Veränderungen in
              der Bedrohungslage, neue Sicherheitsanforderungen oder
              Veränderungen im Unternehmen können dazu führen, dass zuvor
              akzeptierte Risiken nach einer Neubewertung 
              gegebenenfalls aufgrund geänderter Umstände anderes gesteuert werden müssen. 
            </p>{" "}
            <h3 className="p-5">Gründe für die Akzeptanz von Rest-Risiken</h3>
            <p className="col-lg-11 mx-auto">
              In vielen Fällen ist es{" "}
              <strong> wirtschaftlich nicht sinnvoll, </strong> jedes Risiko
              vollständig auszuschalten. Wenn die Kosten für zusätzliche
              Sicherheitsmaßnahmen die potenziellen Auswirkungen eines Risikos
              übersteigen, kann es ratsam sein, das Risiko zu akzeptieren, statt
              weitere Ressourcen zur Risikominimierung aufzuwenden.
              <br />
              <br />
              Einige Risiken haben eine so{" "}
              <strong>niedrige Eintrittswahrscheinlichkeit, </strong> dass die
              Wahrscheinlichkeit eines Schadens als äußerst unwahrscheinlich
              betrachtet wird. Solche Risiken können in der Regel akzeptiert
              werden, wenn die Kosten der Risikominderung unverhältnismäßig hoch
              sind.
              <br />
              <br />
              Rest-Risiken mit begrenzten oder{" "}
              <strong>tolerierbaren Auswirkungen </strong>auf das Unternehmen
              können ebenfalls akzeptiert werden. Diese Risiken betreffen das
              Unternehmen nicht in erheblichem Maße und stellen daher kein
              existenzielles Risiko dar.
            </p>
            <p className="col-lg-11 mx-auto">
Für manche Risiken sind Steuerungsmaßnahmen derart kostspielig, dass das Management solche Risiken und damit womöglich sogar den Untergang des Unternehmens einfach hinnehmen muss. 

            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Viele Unternehmen akzeptieren kleinere Risiken, da es schlichtweg
              zu teuer wäre, jedes Risiko vollständig zu eliminieren. Studien
              zeigen, dass 90% der Unternehmen bewusst Rest-Risiken in Kauf
              nehmen und stattdessen ihre Ressourcen vor allem auf die größten und
              kritischsten Bedrohungen konzentrieren.
            </p>
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 ">
            <h3 className="p-5">Kosten-Nutzen-Analyse zur Risikoakzeptanz</h3>
            <p className="col-lg-11 mx-auto">
              Eine Kosten-Nutzen-Analyse zur Risikoakzeptanz in der
              Cybersecurity hilft Unternehmen, die Kosten für
              Sicherheitsvorkehrungen gegen potenzielle Schäden abzuwägen. Eine solche Analyse dient dazu, die
              optimale Balance zwischen Schutz und Kosten zu finden.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Finanzinstitute führen häufig Kosten-Nutzen-Analysen durch, um zu
              entscheiden, welche Risiken akzeptabel sind. Viele Banken
              akzeptieren z. B. kleinere Rest-Risiken im Bereich des
              Online-Bankings, da die Kosten zur vollständigen Eliminierung
              dieser Risiken unverhältnismäßig hoch wären. Stattdessen setzen
              sie auf proaktive Überwachung und rasche Reaktionsstrategien.
            </p>
            <p className="col-lg-11 mx-auto">
              Die Kosten-Nutzen-Analyse hilft, die Kosten potenzieller Schäden gegen die Kosten der Sicherungsmaßnahmen 
              abzuwägen. So kann z. B. ermittelt werden, wie viel in präventive Maßnahmen
              investiert werden sollte, um Schäden durch Cyberangriffe zu
              vermeiden. Dann wird geschätzt, wie hoch die finanziellen,
              reputationsbezogenen und betrieblichen Verluste im Schadensfall
              wären und wie die geplanten Sicherheitsmaßnahmen wirken würden.
              
            </p>
            <h3 className="p-5">Elemente der Kosten-Nutzen-Analyse:</h3>

            <div class="container text-center">
              <div class="row align-items-center">
                <div class="col">
                  <h5 className="text-center p-3">Kosten</h5>
                  <p>
                    Hier werden die Kosten für Cybersecurity-Maßnahmen erfasst,
                    einschließlich Technologien wie Firewalls, Intrusion
                    Detection Systeme (
                    <Link to="/cybersecurity/4_3#ids" className="icon-link">
                      <svg className="bi" aria-hidden="true">
                        <use xlinkHref="#book"></use>
                      </svg>{" "}
                      IDS
                    </Link>
                    ), Verschlüsselung, Personalaufwand und Schulungen.
                  </p>
                </div>
                <div class="col">
                  <h5 className="text-center p-3">Nutzen</h5>
                  <p>
                    Auf der Nutzenseite wird geschätzt, in welchem Umfang Verluste aus potenziellen Schäden (Datenverluste,
                    Betriebsunterbrechungen oder Imageschäden) verringert werden
                    könnten. 
                  </p>
                </div>
              </div>
            </div>
            <h5 className="text-center pt-5">Wirtschaftliche Kennzahlen</h5>
            <p className="col-lg-11 pt-3 mx-auto">
              Zur Bewertung der Maßnahmen werden Kennzahle wie z. B. der{" "}
              <strong>Return on Security Investment </strong>(ROSI)
              herangezogen. Der ROSI wird berechnet, indem der Nutzen des Verhältnis zu den
              Sicherheitskosten gesetzt wird. Ein hoher ROSI zeigt, dass die
              Sicherheitsmaßnahme gut
              zum Schutz beiträgt. <br />
              <br />
            </p>

            <ROSIChart />
            <p className="col-lg-11 mx-auto">
              {" "}
              <br />
              <br /> Der Chart vergleicht für mehrere Sicherheitsmaßnahmen jeweils die
  <strong> Kosten der Maßnahme</strong> mit dem
  <strong> vermiedenen erwarteten Schaden</strong>. Zusätzlich zeigt die
  ROSI-Linie, wie wirtschaftlich die jeweilige Maßnahme ist.
  So wird auf einen Blick deutlich, welche Maßnahmen aus finanzieller Sicht
  besonders vorteilhaft sind.
              
            </p>
            <h3 className="p-5">
              {" "}
              <br />
              <br />
              Entscheidungskriterien:
            </h3>
            <p className="col-lg-11 mx-auto">
              <strong>
                Wenn die vermiedenen Verluste aus einem bestimmten Risiko höher sind als die präventiven Kosten zur Abwehr dieses Risikos, lohnt es sich, in
                präventive Maßnahmen zu investieren.
              </strong>
              <br />
              <br />
              <strong>
                Ist der finanzielle Schaden eines potenziellen Vorfalls
                überschaubar und die Kosten für die vollständige Abwehr sind sehr
                hoch, könnte das Risiko als akzeptabel betrachtet werden.
              </strong>{" "}
              <br />
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container pt-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />

            <h3 className="p-5">Risikominderung mittels Kombination von Prävention und Reaktion</h3>
            <p className="col-lg-11 mx-auto">
              Eine umfassende Cybersecuritysstrategie kombiniert präventive und
              reaktive Maßnahmen, um Sicherheitsrisiken zu minimieren und
              schnell auf Vorfälle reagieren zu können. Präventive Maßnahmen
              schließen Schwachstellen, bevor sie ausgenutzt werden. Wie umfassen regelmäßige Schwachstellenscans, Vorgabe von Sicherheitsstandards,
              Patch-Management und Zugangskontrollen wie die{" "}
              <Link to="/cybersecurity/2_3#mfa" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Multi-Faktor-Authentifizierung (MFA)
              </Link>{" "}
              . Diese Schutzmaßnahmen senken das Risiko eines erfolgreichen
              Angriffs, indem sie das Sicherheitsniveau kontinuierlich auf dem
              neuesten Stand halten und unautorisierten Zugriff verhindern.
              <br />
              <br />
              Reaktive Maßnahmen greifen, wenn trotz Prävention ein Vorfall
              auftritt. Ein{" "}
              <Link to="/cybersecurity/4_5#ir" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Incident Response
              </Link>{" "}
              Team (IRT) analysiert die Situation, ergreift Maßnahmen zur
              Eindämmung und sorgt für eine rasche Wiederherstellung der
              Systeme. Unterstützt wird dies durch Notfallprotokolle und
              Echtzeit-Überwachung, die ungewöhnliche Aktivitäten sofort
              erkennen und Alarm schlagen. Die forensische Analyse nach einem
              Angriff hilft, die Ursachen schlagend gewordener Risiken zu verstehen und Sicherheitslücken zu
              schließen, um künftige Vorfälle der gleichen Art zu verhindern.
              <br />
              <br />
              Das Zusammenspiel beider Ansätze gewährleistet eine starke
              Widerstandsfähigkeit: Prävention senkt das Risiko, dass Angriffe
              erfolgreich sind, während Reaktion sicherstellt, dass im Ernstfall
              schnell gehandelt wird, um die Verlusthöhe einzudämmen. Durch regelmäßige Nachbereitung und
              Anpassung der Sicherheitsmaßnahmen wird die Resilienz des
              Unternehmens weiter gestärkt. 
            </p>

           
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter7_4;
